import {ArticleList} from '../article-list/article-list.comp';
// import {Loader} from '../../../common/loader.comp';
import {EventType} from '../../../common/logger/event-type';
import {BaseWidgetProps} from '../../widget-container';
import * as React from 'react';
// import {translate} from '../../../common/translate';
import { Article } from '@wix/answers-api';
import { fedopsInteractions } from '../../../common/fedops-interactions';

export type SearchResultsProps = {
	baseConfig: BaseWidgetProps,
	term: string;
};

export class SearchResults extends React.Component<SearchResultsProps, any> {
	state = {
		searchTerm: '',
		searchResults: [],
		isLoadingResults: false
	};

	constructor (props: SearchResultsProps) {
		super(props);
	}

	componentDidMount () {
		const term = this.props.term;
		this.updateAndSearch(term);
	}

	componentWillReceiveProps (nextProps: SearchResultsProps) {
		const term = nextProps.term;
		this.updateAndSearch(term);
	}

	updateAndSearch (term: string) {
		if (term.length > 1 && term !== this.state.searchTerm) {
			this.setState({ searchTerm: term }, () => {
				this.search(term);
			});
		}
	}

	search (value: string) {

		const {baseConfig} = this.props;
		baseConfig.getFedopsLogger().interactionStarted(fedopsInteractions.searchArticle);
		this.setState({ searchTerm: value });
		this.setState({ isLoadingResults: true });
		baseConfig.kbApi.textualSearch(value)
		.then((articles: any) => {
			this.setState({ isLoadingResults: false, searchResults: articles });
			baseConfig.widgetNavigator.onSearchCompleted(articles, value, baseConfig.logger.logEvent);
			baseConfig.getFedopsLogger().interactionEnded(fedopsInteractions.searchArticle);
		})
		.catch(() => {
			this.props.baseConfig.getFedopsLogger().interactionEnded(fedopsInteractions.searchArticle);
		});
	}

	logArticleClicked = (article: Article, position: number) => {
		this.props.baseConfig.logger.logEvent(EventType.SEARCH_RESULT_CLICK, {
			term: this.state.searchTerm,
			articleId: article.id,
			articleTitle: article.title,
			articleUri: article.uri,
			position
		});
	}

	render () {
		const state = this.state;
		const translate = this.props.baseConfig.translate;
		const searchResultsComp = (
			<div className='search-results'>
				<h3>{translate('widget-ng.search-results.title', {term: state.searchTerm})}</h3>
				<ArticleList
					articles={state.searchResults}
					goToState={this.props.baseConfig.widgetNavigator.goToState}
					withIcons={true}
					onSelectCallback={this.logArticleClicked}
				/>
			</div>
		);
		const noResultsComp = (
			<div className='no-results-container'>
				<h3>{translate('widget-ng.search-results.no-results')}</h3>
			</div>
		);
		const searchResults = this.state.searchResults.length ? searchResultsComp : noResultsComp;
		// const loadResultsComp = (
		// 	<Loader className='inner-page' color={this.props.baseConfig.widgetConfig.appearance.brandColor}/>
		// );
		return (
			<div className='search-results-page kb-page'>
				{this.state.isLoadingResults ? null : searchResults}
			</div>
		);
	}
}
